import { auth0RedirectUriDev } from '../app/utils/auth/auth-helpers'

export const environment = {
    baseURL: 'https://chat.devapifyxt.com',
    useLanggraph: true,
    showReasoningLogs: true,
    keycloakConfig: {
      realm: "dev-v2",
      url: 'https://keycloak.devfyxt.com/auth',
      clientId: 'web-login-v2',
    },
    auth0: {
      auth0Domain: 'auth.devfyxt.com',
      clientId: 'mk5eChLqsqoh3WeNtKcYGn1t9Yjtp0MP',
      audience: 'https://dev-aip80j0jjbyehsu7.us.auth0.com/api/v2/',
      redirectUri: auth0RedirectUriDev,
      useRefreshTokens: false,
      allowedDomains: [
        'realtyincome.devfyxt.com',
        'midamerica.devfyxt.com',
        'fcpt.devfyxt.com'
      ],
      urlPatterns: [] // Example: ['/tenant', '/public'] - add your specific URL patterns here
    },
}
